import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import './EquipBrowser.css';

class EquipBrowser extends Component {
  render() {
    const data = [{
      name: 'Oscilloscope',
      brand: 'Rigol',
      quantity: '40',
      college: 'St. Olaf',
      imgUrl: 'https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcSO3RT9l0hD3P8jwL7nv_WRMHEgJb8FTA4v1W4o4KtPOWqSAADq2P5Jox6bbON0geOIOGgQru8&usqp=CAE',
      moveable: 'Yes',
      shareable: 'No',
    },
    {
      name: 'Function Generator',
      brand: 'Rigol',
      quantity: '10',
      college: 'St. Olaf',
      imgUrl: 'https://core-electronics.com.au/media/catalog/product/cache/1/image/fe1bcd18654db18f328c2faaaf3c690a/d/g/dg1022_1.jpg',
      moveable: 'Yes',
      shareable: 'Yes',
    },
    {
      name: 'Function Generator',
      brand: 'Rigol',
      quantity: '09',
      college: 'Carleton',
      moveable: 'Yes',
      imgUrl: 'https://core-electronics.com.au/media/catalog/product/cache/1/image/fe1bcd18654db18f328c2faaaf3c690a/d/g/dg1022_1.jpg',
      shareable: 'Yes',
    },
    {
      name: '8 Socket Light Box',
      brand: 'Carleton',
      quantity: '10',
      college: 'Carleton',
      moveable: 'Yes',
      imgUrl: 'https://i.ebayimg.com/00/s/NzY4WDEwMjQ=/z/hWoAAOSwWv5aFAY9/$_86.JPG',
      shareable: 'Yes',
    }]

    return (
      <div className="mainContainer">
        <ReactTable
          data={data}
          showPageSizeOptions={false}
          style={{flex: 1, padding: '.5em'}}
          columns={[
            {
              Header: 'Image',
              Cell: (row) => {
                return <div><img alt='' height={34} src={row.original.imgUrl} /></div>
              }
            },
            {
              Header: "Name",
              accessor: 'name',
            },
            {
              Header: "Brand",
              accessor: 'brand'
            },
            {
              Header: 'Quantity',
              accessor:'quantity'
            },
            {
              Header: 'Moveable',
              accessor: 'moveable'
            },
            {
              Header: 'Shareable',
              accessor: 'shareable'
            },
            {
              expander: true,
              Header: () => <strong>More</strong>,
              width: 65,
              Expander: ({ isExpanded, ...rest }) =>
                <div>
                  {isExpanded
                    ? <span>&#x2299;</span>
                    : <span>&#x2295;</span>}
                </div>,
              style: {
                cursor: "pointer",
                fontSize: 25,
                padding: "0",
                textAlign: "center",
                userSelect: "none"
              },
            }
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
          SubComponent={(row) => <div style={{padding: '10px'}}><img alt='' src={row.original.imgUrl}/></div>}
        />
      </div>
    )
  }
}

export default EquipBrowser;



// WEBPACK FOOTER //
// ./src/components/EquipBrowser/EquipBrowser.js